<template>
  <div class="about">
    <div class="is-hidden-touch" v-if="getViewPort() >= 1000">
      <navbar />
      <GeneralHero page="Privacy Policy" />
      <div v-if="!$store.getters.getLoading">
        <PrivacyPolicy />
      </div>
      <Footer />
    </div>
    <div class="is-hidden-desktop" v-else>
      <NavMobile />
      <GeneralHeroMobile page="Privacy Policy" />
      <div v-if="!$store.getters.getLoading">
        <PrivacyPolicy />
      </div>
      <FooterMobile />
    </div>
  </div>
</template>

<script>
// import HelloWorld from '../components/HelloWorld'
import Navbar from "../components/GeneralComponent/Navbar";
import NavMobile from "../components/mobile/GeneralComponent/Navbar";
import GeneralHero from "../components/GeneralComponent/GeneralHero";
import GeneralHeroMobile from "../components/mobile/GeneralComponent/GeneralHero";
import PrivacyPolicy from "../components/PrivacyPolicyComponent/PrivacyPolicy";
import Footer from "../components/GeneralComponent/Footer";
import FooterMobile from "../components/mobile/GeneralComponent/Footer";

export default {
  name: "Policy",
  methods: {
    getViewPort() {
      return (window.innerWidth);
    }, //end of getViewPort
  },
  components: {
    // HelloWorld,
    Navbar,
    NavMobile,
    GeneralHero,
    GeneralHeroMobile,
    PrivacyPolicy,
    Footer,
    FooterMobile,
  },
};
</script>
